// extracted by mini-css-extract-plugin
export var cta = "gf_k2";
export var cta_circleBg = "gf_n2";
export var cta_form = "gf_q2";
export var cta_ill = "gf_m2";
export var cta_inner = "gf_l2";
export var cta_text = "gf_p2";